// §12 roadmap rows for the report pages — ONE builder, so Report.jsx and
// SharedReport.jsx cannot drift from each other or from the engine. No month
// is computed here: the phase window comes from `result.milestones` and the
// milestone months from `result.schedule`, both authored by backend
// `schedule.py`, which is also what v3 §12, the memo, the XLSX and the CSV
// read.

import { getLocale } from "./i18n";

// French for the engine's phase activities (backend schedule.py PHASE_ACTIVITIES).
const ACT_FR = {
  "Access and civils set-out": "Accès et implantation du génie civil", "Bankable feasibility": "Faisabilité bancable",
  "Civils and foundations": "Génie civil et fondations", "Commissioning and performance test": "Mise en service et essais de performance",
  "Contractor mobilisation": "Mobilisation de l'entreprise", "Detailed design": "Conception détaillée", "EPC tender": "Appel d'offres EPC",
  "Environmental screening / ESIA": "Examen environnemental / EIES", "Equipment specification": "Spécification des équipements",
  "Financial close": "Bouclage financier", "Generation & grid permits": "Permis de production et de raccordement",
  "Grid interface": "Interface réseau", "Land and site control": "Maîtrise foncière du site",
  "Load profile validation": "Validation du profil de charge", Manufacture: "Fabrication",
  "Mechanical & electrical install": "Installation mécanique et électrique", "O&M handover": "Transfert à l'exploitation-maintenance",
  "Performance monitoring": "Suivi des performances", "Permit strategy": "Stratégie d'autorisation",
  "Reservation agreement": "Accord de réservation", "Shipping and delivery": "Transport et livraison",
  "Site establishment": "Installation de chantier", "Site survey": "Relevé de site",
};

export function roadmapRows(milestones, schedule, t) {
  const rows = (milestones || []).map((ph) => {
    const label = ph.key
      ? t(`report.roadmap.phase.${ph.key}`, ph.phase)
      : ph.phase;
    const s = ph.start_month;
    const e = ph.end_month;
    let months = "—";
    if (s !== null && s !== undefined) {
      months = (e === null || e === undefined)
        ? `${t("report.roadmap.from_month")} ${s}`
        : `${t("report.roadmap.months_label")} ${s}–${e}`;
    }
    const dur = ph.duration_months
      ? `${ph.duration_months} ${t("report.roadmap.months")}`
      : t("report.roadmap.ongoing");
    const fr = getLocale() === "fr";
    const acts = (ph.activities || []).map((a) => (fr ? ACT_FR[a] ?? a : a)).join(fr ? "\u00a0; " : "; ");
    return [acts ? `${label} — ${acts}` : label, `${months} · ${dur}`];
  });
  ((schedule || {}).milestones || []).forEach((ms) => {
    rows.push([
      t(`report.roadmap.${ms.key}`, ms.key),
      `${t("report.roadmap.month")} ${ms.month}`,
    ]);
  });
  return rows;
}

export function roadmapLeadNote(schedule, t) {
  const s = schedule || {};
  if (s.driver !== "equipment_lead_time") return "";
  const eq = s.equipment || {};
  return t("report.roadmap.lead_note")
    .replace("{tech}", t(`report.roadmap.tech.${eq.tech}`, eq.tech || ""))
    .replace("{lead}", eq.lead_months)
    .replace("{build}", eq.build_months);
}
